import { render, staticRenderFns } from "./BrandContentRadarModal.vue?vue&type=template&id=6ab54826"
import script from "./BrandContentRadarModal.vue?vue&type=script&lang=js"
export * from "./BrandContentRadarModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports